import { IMessage } from "Interfaces/IMessage";
import { Message } from "Models/Message";
import { Action } from "redux";

export interface IMessageToasterState {
    message?: IMessage;
}

export class MessageToasterState implements IMessageToasterState {
    public message: IMessage = new Message();
}

export const enum ActionTypes {
    SHOW_MESSAGE = "SHOW_MESSAGE",
    CLEAR_MESSAGE = "CLEAR_MESSAGE",
}

export interface IShowMessageToasterAction extends Action {
    type: ActionTypes.SHOW_MESSAGE;
    data: IMessage;
}

export interface IClearMessageToasterAction extends Action {
    type: ActionTypes.CLEAR_MESSAGE;
    data?: IMessage;
}

export type MessageToasterActions = IShowMessageToasterAction | IClearMessageToasterAction;


// WEBPACK FOOTER //
// ./src/Store/MessageToaster/MessageToasterActionTypes.tsx